<div class="row mt-5">
  <div class="col-lg-12 text-center">
    <h2 class="mb-4">Sorry, this page doesn't exist</h2>
    <a class="btn btn-lg btn-outline-dark" routerLink="/"><i class="fas fa-arrow-left"></i>&nbsp;go back to home</a>
  </div>
</div>
